import React from "react";
import LoginInput from "components/auth/common/LoginInput";

interface GuestIdentity {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
}

interface GuestIdentityFieldsProps {
  value: GuestIdentity;
  onChange: (prop: string) => (value: string) => void;
}

const GuestIdentityFields: React.FC<GuestIdentityFieldsProps> = ({
  value,
  onChange,
}) => {
  return (
    <>
      <LoginInput
        label="First Name"
        value={value.firstName}
        name="firstName"
        onChange={onChange}
        type="text"
        placeholder="First Name"
      />
      <LoginInput
        label="Last Name"
        value={value.lastName}
        name="lastName"
        onChange={onChange}
        type="text"
        placeholder="Last Name"
      />
      <LoginInput
        label="Email"
        value={value.email}
        name="email"
        onChange={onChange}
        type="text"
        placeholder="Email Address"
      />
      <LoginInput
        label="Phone (optional)"
        value={value.phone}
        name="phone"
        onChange={onChange}
        type="text"
        placeholder="Phone Number"
      />
    </>
  );
};

export default GuestIdentityFields;
